// extracted by mini-css-extract-plugin
export default {"campaign-container":"Campaign_campaign-container__SAjGj","campaign-text":"Campaign_campaign-text__KFssn","campaign-image":"Campaign_campaign-image__jCbfC"};